<template>
  <div  v-if="show_body">
    <!-- 测评答题 -->
    <!-- :intro="data.intro?data.intro.split('\n'):[]" -->
    <answer-sheet3 :array="data.list" :cid="data.cid" :data_="data" :path="$route.path" :interruptShow="interruptShow"  @saveReportHandle="saveReportHandle"></answer-sheet3>
    <!-- 未购买 -->
    <van-popup class="pub_alert" v-model="is_buy" :close-on-click-overlay="false">
      <div class="confirm_box">
        <h2>此测评属于最佳工作模式课程，快去购买课程测评吧</h2>
        <div class="btn_group">
          <!-- 跳转自我探索课程 -->
          <router-link class="cancel" :to="{
            path:'/course_details',
            query:{
              bid:2
            }
          }">购买最佳工作模式课程</router-link>
        </div>
      </div>
    </van-popup>

    <!-- 判断链接是否失效 -->
    <van-popup class="pub_alert" v-model="failureShow" :close-on-click-overlay="false">
        <div class="confirm_box">
            <h2 class="on">{{failureMsg}}</h2>
        </div>
    </van-popup>
    <!-- 关卡介绍 -->
    <public-level :level_list_id="level_list_id" :cpBool="true"></public-level>
  </div>
</template>
<script>
import { ceping95_section,ceping95_answer,ceping_event} from '@/api/measurement'
import {
  queryString,
  getStorage,
  setStorage,
  deleteStorage
} from '@/utils/tools'
import { shareCon } from "@/utils/wxconfig";
import AnswerSheet3 from "@c/measurement/answer-sheet3";
import PublicLevel from '@c/course/public-level'
export default {
  data() {
      return {
        show_body: false,
        //
        nickname: "",
        data: {},
        // 上一页面路由
        formPath: '',
        interruptShow:false,
        // 答题说明页数据
        failureShow:false,
        failureMsg:'',
        // 关卡
        level_list_id:''
      }
    },
    components:{
      AnswerSheet3,
      PublicLevel
    },
    computed: {
      is_buy(){
        return (!this.data.is_buy && !this.data.msg)
      }
    },
    methods: {
      /*
       *@param: 
       *@return: 
       *@Description: 获得提交的答题数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-01 15:28:13
      */
      saveReportHandle(arr){
        //调用加载中
        this.$emit('loadingHandle',true,"提交中...");
        ceping95_answer({
          answer: JSON.stringify(arr)
        })
        .then((data) => {
          //关闭加载中
          this.$emit('loadingHandle',false);
          if (data.code == 10002) {
            this.$toast(data.data.msg);
            return false;
          }
          this.$toast('提交成功！');
          let q = this.$route.query;
          // 提交删除缓存 
          deleteStorage(this.$route.path);
          deleteStorage('/an_questions3');
          if (this.formPath === '/ceping95_report') {
            this.$router.back();
          } else {
            this.$router.push({
              path: '/ceping95_report',
              query: q
            })
          }
        })
      },
      pullData() {
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
        let q = this.$route.query;
        // 获取关卡信息
        this.level_list_id = q.level_list_id?q.level_list_id:'';
        let obj = {
          state: this.$route.query.state,
        };
        if(this.$route.query.code){
          obj['code'] = this.$route.query.code;
        }
        ceping95_section(obj)
          .then((data) => {
            if (data.code == 10002) {
              if (this.formPath === '/ceping95_report') {
                this.$router.back();
              } else {
                // 已经测评完成
                this.$router.push({
                  path:'/ceping95_report',
                  query:this.$route.query
                })
              }

            } else {
              this.data = data;
              //判断是否是已购买课程并且链接已使用或者失效
              if(data.msg){
                this.failureMsg = data.msg;
                this.failureShow = true;
              }else{
                //判断是否是已购买课程并且有本地缓存
                if(data.is_buy){
                  this.interruptShow = true;
                }
              }
              this.nickname = data.nickname;
              this.show_body = true;
              document.getElementsByTagName('body')[0].style.height = window.innerHeight + 'px';

              ceping_event({ lead_sid: this.$route.query.lead_sid,
                cid: data.cid,
                event: 'ViewIndex',
              }).then(res=>{
                // 页面访问统计
              });
              
              // 神策统计--打开页面时触发
              // sensors.track('evaluationPage', {
              //   evaluation_id: data.cid,
              //   evaluation_name: data.headtitle,
              //   evaluation_url: window.location.href,
              //   evaluation_page_title: data.headtitle,
              //   share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
              //   channel_name: this.$route.query.channel ? this.$route.query.channel : ""
              // })

            }
            //关闭加载中
            this.$emit('loadingHandle',false);
          })
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.formPath = from.path;
      })
    },
    created() {
      this.pullData();
      if(this.$route.query.clearCache){
        deleteStorage(this.$route.path);
      }
      // shareCon("measurement", this);
    }
}
</script>
<style lang="scss" scoped>

@import "@s/remChange.scss";
.test-list {
  padding: 32px;
  overflow-x: hidden;
  padding-bottom: 750px;
}
.test-list.on{
  position:absolute;
  top:0;
  left: 0;
  height: 100%;
  overflow: hidden;
}

.progress {
  position: fixed;
  height: 8px;
  left: 0;
  top: 0;
  z-index: 3;
  background: #F57F17;
  transition: all .3s;
}
.pg-num {
  position: fixed;
  padding: 10px;
  top: 10px;
  right: 10px;
  z-index: 4;
  background: red;
  transition: all .3s;
  color: #fff;
  border-radius: 30px;
}

.mt32 {
  margin-top: 32px;
}

.pt32 {
  padding-top: 32px;
}

.pb-public {
  padding: changeRem(0.425)+px;
}

.item-inter {
  transform: translateY(0px);
  opacity: 0;
  .ico-box {
    width: changeRem(1.75)+px;
    height: changeRem(1.75)+px;
    border-radius: changeRem(1.75)+px;
    overflow: hidden;
    img {
      max-width: 100%;
    }
  }
  .pd-row-2 {
    margin-top: 24px;
  }
  .item-text {
    font-size: changeRem(0.6)+px;
  }
  .item-radius {
    border-radius: changeRem(0.17)+px;
  }
  .alert-con {
    overflow: hidden;
  }
  .active_a {
    color: #EB5032;
    text-decoration: underline;
  }
}


/* 左 */

.inter-left {
  .ico-box {
    left: 5px;
    top: 5px;
  }
  .item-text {
    margin-left: changeRem(0.5)+px;
    max-width: 465px;
    color: #fff;
  }
  .alert-con {
    padding: changeRem(0.425)+px;
    background: #F57F17;
  }
  .caret {
    width: 0px;
    height: 0px;
    left: changeRem(-0.3)+px;
    top: changeRem(0.1)+px;
    margin-top: changeRem(0.7)+px;
    border-top: changeRem(0.2)+px solid rgba(0, 160, 246, 0);
    border-right: changeRem(0.3)+px solid #F57F17;
    border-bottom: changeRem(0.2)+px solid rgba(0, 160, 246, 0);
  }
}


/* 右 */

.inter-right {
  .item-text {
    margin-right: changeRem(0.5)+px;
  }
  .alert-con {
    background: #fff;
  }
  .caret {
    width: 0px;
    height: 0px;
    right: changeRem(-0.3)+px;
    top: changeRem(0.1)+px;
    margin-top: changeRem(0.7)+px;
    border-top: changeRem(0.2)+px solid rgba(255, 255, 255, 0);
    border-left: changeRem(0.3)+px solid rgba(255, 255, 255, 1);
    border-bottom: changeRem(0.2)+px solid rgba(255, 255, 255, 0);
  }
}

.next-box {
  border-top: 2px solid #fff;
  margin-top: changeRem(0.35)+px;
  padding-top: changeRem(0.35)+px;
}

.item-answer-left-animation {
  animation: item-answer-animation 0.8s;
  animation-fill-mode: forwards;
}

.item-answer-right-animation {
  animation: item-answer-animation 0.8s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
}

.pop {
  img {
    max-width: 8rem;
  }
}

.radius {
  border-radius: 10px;
}

.confirm_box {
  h2 {
    padding: 40px 30px;
  }
  h2.on{
    padding: 60px 30px;
  }
  p {
    margin-bottom: 50px;
    font-size: 26px;
    color: #666;
  }
  .btn_group {
    .confirm{
      color: #999999;
    }
    .cancel{
      color:#EB5032;
    }
  }
}
/*
 *继续答题弹窗样式
 *
*/
.go-on-questions{
  display: flex;
  flex-direction: column;
  background-color: #fff;
  color: #333333;
  border-radius: 12px;
  padding:30px 50px 50px 50px;
  width: 540px;
  .questions-header{
    font-size: 34px;
    display: flex;
    align-items: flex-start;
    span{
      margin-left: auto;
    }
  }
  .questions-content{
    font-size: 28px;
    text-align: center;
    margin: 70px auto;
  }
  .questions-footer{
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 28px;
    .redoBtn{
      color: #999999;
      border-radius: 12px;
      line-height: 65px;
      width: 200px;
      border: 0;
    }
    .questionsBtn{
      background-color: #EB5032;
      color: #ffffff;
      border-radius: 12px;
      line-height: 65px;
      width: 200px;
      border: 0;
    }
  }
  
}
// 弹出开始测评说明
.answer-sheet{
  transition: all 2s;
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.answer-sheet.on{
  left: -1500px;
}
</style>
<style>
.active {
  color: #F57F17;
  font-weight: bold;
}

.alert-radio-group .van-cell {
  font-size: 0.37rem;
  line-height: 0.64rem;
  position: relative;
  border-bottom: 2px solid #ddd;
}

.alert-radio-group .van-cell:last-child {
  border-bottom: none;
}

.alert-radio-group .van-radio__icon {
  height: 0.55rem;
  line-height: 0.53rem;
}

.alert-radio-group .van-cell__title {
  position: relative;
  z-index: 1;
}

.alert-radio-group .van-radio__icon .van-icon {
  width: 0.53rem;
  height: 0.53rem;
  border-width: 2px;
}

.alert-radio-group [class*=van-hairline]::after {
  border: none;
}

.alert-radio-group .van-cell:not(:last-child)::after {
  border: none;
}

.alert-radio-group .van-cell__title span {
  display: block;
  width: 3.3rem;
  margin-right: -0.6rem;
}


/* 动画 */

@keyframes item-answer-animation {
  0% {
    transform: translateY(80px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

html,
body {
  height: 100%;
}
</style>
